export const SET_DATA = 'AUTH/SET_DATA'
export const ADMITAD_AUTH = 'AUTH/ADMITAD_AUTH'
export const TRY_START_SESSION = 'AUTH/TRY_START_SESSION'
export const TWO_FACTOR = 'AUTH/TWO_FACTOR'
export const LOGOUT = 'AUTH/LOGOUT'
export const ACTIVATE = 'AUTH/ACTIVATE'
export const LOGIN_SUBMIT = 'AUTH/LOGIN_SUBMIT'
export const RECOVER_PASSWORD = 'AUTH/RECOVER_PASSWORD'
export const RECOVER_SUBMIT = 'AUTH/RECOVER_SUBMIT'
export const REGISTRATION_SUBMIT = 'AUTH/REGISTRATION_SUBMIT'
export const SET_AUTH = 'AUTH/SET_AUTH'
export const EMAIL_REQUEST_CONFIRMATION = 'AUTH/EMAIL_REQUEST_CONFIRMATION'
